export default "__VITE_ASSET__CWwxOdTs__"